import React, { useState } from "react";
import { Card, CardText, CardTitle, Col } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// Course card component with individual hover state
const BlueCard = ({ title, description, icon, path }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(path);
  };

  return (
    <Card
      className="all-courses-cards h-100"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleNavigate}
      style={{
        position: "relative",
        cursor: "pointer",
      }}
    >
      <div className="d-flex align-items-start p-md-3">
        <div className="me-3" style={{ width: "90px" }}>
          {icon}
        </div>
        <div>
          <CardTitle className="text-white mb-2">{title}</CardTitle>
          <CardText className="text-white">{description}</CardText>
        </div>
      </div>
      {isHovered && (
        <div
          className="position-absolute d-flex align-items-center"
          style={{
            bottom: "15px",
            right: "15px",
            transition: "opacity 0.3s",
            opacity: isHovered ? 1 : 0,
            color: "white",
            pointerEvents: "none",
          }}
        >
          <span className="me-2">Click to Continue</span>
          <FaArrowRight />
        </div>
      )}
    </Card>
  );
};

// Container component that receives coursesData as props
const BlueCards = ({ coursesData }) => {
  return (
    <>
      {coursesData.map((course) => (
        <Col key={course.id} lg={4} md={6} className="mb-3 mb-md-4">
          <BlueCard
            title={course.title}
            description={course.description}
            path={course.path}
            icon={
              <course.icon
                size={60}
                color="white"
                style={{
                  width: "60px",
                  height: "60px",
                }}
              />
            }
          />
        </Col>
      ))}
    </>
  );
};

export default BlueCards;
